import { Investment } from '@tcs/client-portal-api/types/Investment';
import { useAccountInvestmentTransactions } from '@tcs/client-portal-common/hooks/useAccountTransactions';
import { doesInvestmentHaveUnits } from '@tcs/client-portal-common/utils/doesInvestmentHaveUnits';
import TransactionsTable from '@tcs/client-portal-common/components/molecules/AssetActivityTable';

interface Props {
  accountNumber: string;
  accountHolding: Investment;
  onBackButtonClick: () => void;
}

const AssetTransactionTable = ({
  accountNumber,
  accountHolding,
  onBackButtonClick,
}: Props) => {
  const { data, loading } = useAccountInvestmentTransactions(
    accountNumber,
    accountHolding.assetCode,
    accountHolding.institutionCode
  );

  const showUnits = doesInvestmentHaveUnits(accountHolding);

  return (
    <TransactionsTable
      accountNumber={accountNumber}
      accountHolding={accountHolding}
      transactions={data}
      showBalance={false}
      showUnits={showUnits}
      loading={loading}
      onBackButtonClick={onBackButtonClick}
    />
  );
};

export default AssetTransactionTable;
